import {PAYMENT_STATUS} from "@/consts";

export default [
    {
        path: '/checkout/mercado-pago/:status',
        name: 'checkout-mercado-pago-complete',
        props: true,
        component: () => import(/* webpackChunkName: "checkout-success" */ '../views/CheckoutMercadoPagoComplete.vue'),
        meta: {
            requiresAuth: true,
            showNavbarCart: false
        },
        beforeEnter: (to, from, next) => {
            const status = to.params.status
            if (PAYMENT_STATUS.includes(status)) {
                next()
            } else {
                next('/checkins')
            }
        }
    },
]

